import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    coinTypeList: [],
    poserlist: [],
    updatePosterDialog: false
  },
  getters: {},
  mutations: {
    setposerlist(state, payload) {
      state.poserlist = payload;
    },
    setupdatePosterDialog(state, payload) {
      state.updatePosterDialog = payload;
    },
    setCoinTypeList(state, payload) {
      state.coinTypeList = payload;
    }
  },
  actions: {
    uploadPoster(context, data) {
      return api.uploadPoster(data);
    },
    updatePoster(context, data) {
      return api.updatePoster(data);
    },
    list({ commit }, data) {
      api.getList(data).then(({ data }) => {
        commit('setposerlist', data);
      });
    },
    remove(context, data) {
      return api.removeList(data);
    },
    getCoinTypeList({ commit }) {
      api.getCoinTypeList().then(({ data }) => {
        commit('setCoinTypeList', data);
      });
    }
  }
};

appStore.registerModule('chatroom', store);
